export default __webpack_public_path__ + "static/media/jasmine_and_ian-249.979c5733.jpg";